export default ({
  state: {
    msg: 'hello demo',
    alert: {}, // {type: 'error', show: true, message: 'hello'}
  },
  mutations: {
    setAlert: (state, payload) => {
      state.alert = payload
    }
  },
  actions: {
  },
  getters: {
  },
});
